<template>
    <div>
        <table class="table table-borderless">
            <template v-for="(step, index) in value">
                <step-editor-step :key="step.Id" v-model="value[index]" :name="'Steps[' + index + ']'"  @removestep="x => removeStep(x, index)" :index="index" :user-list="userList" :editable="editable && !step.IsCompleted"></step-editor-step>
            </template>
            <tbody v-if="!value || value.length == 0">
                <tr>
                    <td class="text-center">
                        <p class="text-muted" style="padding:49px 0">{{translate('errors.pleaseAddStep')}}</p>
                    </td>
                </tr>
            </tbody>
        </table>
        <approval-authority-editor v-if="newApprovalAuthority" v-model="newApprovalAuthority" @cancel="newApprovalAuthority = null" @apply="addStepCompleted" :user-list="newApprovalAuthorityUserList" />
    </div>
</template>

<script>
import ObjectId from '../ObjectId.js'
import StepEditorStep from './StepEditor_step';
import ApprovalAuthorityEditor from './ApprovalAuthorityEditor.vue';

export default {
    name: 'stepEditor',
    components: {
        StepEditorStep,
        ApprovalAuthorityEditor
    },
    data: () => {
        return {
            newApprovalAuthority: null
        };
    },
    props: {
        value: Array,
        userList: Array,
        editable: null
    },
    computed: {
        newApprovalAuthorityUserList(){
            return (this.userList ?? []).filter(x => x.Authorities.some(y => y == 'Approver' || y == 'Signer'));
        },
    },
    methods: {
        addStep(){
            this.newApprovalAuthority = { Kind : "ApprovalAuthorityUser", UserId: null, Id: ObjectId.NewId() };
        },
        addStepCompleted(aa) {
            console.log('addStepCompleted');
            var newStep = {
                Id : ObjectId.NewId(),
                ApprovalAuthorities:[aa],
                Condition: 'Any',
                Action: aa.Kind == 'ApprovalAuthorityExternal' ? 'Sign' : aa.User.Authorities.indexOf('Signer') >= 0 ? 'Sign' : 'Approve'
            };

            this.newApprovalAuthority = null;
            var steps = this.value || [];
            steps.push(newStep);
            this.$emit('input', steps);
        },
        removeStep(step, index) {
            if(confirm(this.translate('errors.stepWillBeRemoved:'+ (1 + index)))) {
                //this.value = this.value.splice(index, 1);
                var steps = this.value.filter(x => x != step);
                this.$emit('input', steps);
            }
        }
    }
}
</script>
